import { usePropertyField } from '../usePropertyField';
import { IApplicationNonRental } from '@apply/api/src/api/ApplyApi';

// ─── NonRental – Core ─────────────────────────────────────────────────────────

export const usePropertyAcquisitionDate = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.acquisitionDate,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), acquisitionDate: v } as IApplicationNonRental })
    );

export const usePropertyYearBuilt = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => {
            const y = p.nonRental?.yearBuilt;
            return y === 0 ? undefined : y;
        },
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                yearBuilt: v,
            } as IApplicationNonRental,
        })
    );

export const usePropertyNumberUnits = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.numberUnits,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), numberUnits: v } as IApplicationNonRental })
    );

export const usePropertyUnitsIncomeRestricted = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.unitsIncomeRestricted,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), unitsIncomeRestricted: v } as IApplicationNonRental })
    );

export const usePropertyVariousUnitsDescription = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.variousUnitsDescription,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), variousUnitsDescription: v } as IApplicationNonRental })
    );

export const usePropertyLandSizeQuantity = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landSize?.quantity,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landSize: { ...(p.nonRental?.landSize ?? {}), quantity: v },
            } as IApplicationNonRental,
        })
    );

export const usePropertyLandSizeUnit = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.landSize?.unit,
        (p, v) => ({
            ...p,
            nonRental: {
                ...(p.nonRental ?? {}),
                landSize: { ...(p.nonRental?.landSize ?? {}), unit: v },
            } as IApplicationNonRental,
        })
    );

export const usePropertyLegalDescription = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.legalDescription,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), legalDescription: v } as IApplicationNonRental })
    );

export const usePropertyCurrentDebt = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.currentDebt,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), currentDebt: v } as IApplicationNonRental })
    );

export const usePropertyDayOfWorkCompleted = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.dayOfWorkCompleted,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), dayOfWorkCompleted: v } as IApplicationNonRental })
    );

export const usePropertyAsIsValue = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.asIsValue,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), asIsValue: v } as IApplicationNonRental })
    );

export const usePropertyExpectedListingPrice = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.expectedListingPrice,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), expectedListingPrice: v } as IApplicationNonRental })
    );

export const usePropertyTargetLoanRequest = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.targetLoanRequest,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), targetLoanRequest: v } as IApplicationNonRental })
    );

export const usePropertyGeneralContractorName = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.generalContractorName,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), generalContractorName: v } as IApplicationNonRental })
    );

export const usePropertyIntendedWork = (propertyGuid: string) =>
    usePropertyField(
        propertyGuid,
        (p) => p.nonRental?.intendedWork,
        (p, v) => ({ ...p, nonRental: { ...(p.nonRental ?? {}), intendedWork: v } as IApplicationNonRental })
    );
